import {$axios} from "../../../utils/axios.instance"

function getDealers(payload) {

  let params = new URLSearchParams();

  if (payload?.search) {
    params.append("search", payload.search);
  }
  if (payload?.page_size) {
    params.append("page_size", payload.page_size);
  }
  if (payload?.page) {
    params.append("page", payload.page);
  }

  params.append("subscribed_only", payload?.subscribed_only ?? true);

  return $axios
    .get(`vendors/all/${params.toString() ? `?${params.toString()}` : ''}`)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}


function addDealer(payload) {
  return $axios
    .post(`vendors/customer-vendors/`, payload)
    .then(res => {
      return res.data
    })
    .catch(function (error) {
      // 
      throw error
    })
}

function deleteDealer(payload) {
  return $axios
    .delete(`vendors/customer-vendors/${payload?.id}/`)
    .then(res => {
      return res.data
    })
    .catch(function (error) {
      // 
      throw error
    })
}

export const dealersAPIService = {
  getDealers,
  addDealer,
  deleteDealer
}
